import { render, staticRenderFns } from "./PopupBanner.vue?vue&type=template&id=4ba3c80e"
import script from "./PopupBanner.vue?vue&type=script&lang=js"
export * from "./PopupBanner.vue?vue&type=script&lang=js"
import style0 from "./PopupBanner.vue?vue&type=style&index=0&id=4ba3c80e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports